/* ============================================================
   JASP — theme.js
   ============================================================ */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function announce(msg) {
    var live = document.querySelector('[data-sr-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }

  /* ---- Mobile nav drawer (accessible) ---- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!toggle || !drawer) return;
    var close = drawer.querySelector('[data-menu-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function shut() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 300);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function trap(e) {
      if (e.key === 'Escape') { shut(); return; }
      if (e.key !== 'Tab') return;
      var nodes = drawer.querySelectorAll(FOCUSABLE);
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    drawer.addEventListener('keydown', trap);
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', shut);
    });
  }

  /* ---- Product gallery + variant selector ---- */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    var variantsData = root.querySelector('[data-variants-json]');
    if (!variantsData) return;
    var variants;
    try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }

    var mainImg = root.querySelector('[data-main-img]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var optionBtns = root.querySelectorAll('[data-opt]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add-btn]');
    var selected = {};

    optionBtns.forEach(function (btn) {
      if (btn.classList.contains('is-active')) {
        selected[btn.dataset.optPos] = btn.dataset.optValue;
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.setAttribute('aria-pressed', 'false');
      }
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.dataset.full; mainImg.removeAttribute('srcset'); }
        thumbs.forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-pressed', 'false');
        });
        t.classList.add('is-active');
        t.setAttribute('aria-pressed', 'true');
      });
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i + 1] === opt; });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var priceText = v.price_formatted || formatMoney(v.price);
      if (priceEl) {
        var hidden = priceEl.querySelector('.visually-hidden');
        priceEl.textContent = '';
        if (hidden) priceEl.appendChild(hidden);
        priceEl.appendChild(document.createTextNode(' ' + priceText));
      }
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-disabled');
          addBtn.textContent = addBtn.dataset.labelAdd;
        } else {
          addBtn.disabled = true;
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = addBtn.dataset.labelSold;
        }
      }
      if (mainImg && v.featured_image) {
        mainImg.src = v.featured_image;
        mainImg.removeAttribute('srcset');
        thumbs.forEach(function (x) {
          var match = x.dataset.full === v.featured_image;
          x.classList.toggle('is-active', match);
          x.setAttribute('aria-pressed', match ? 'true' : 'false');
        });
      }
      announce('Variante : ' + Object.values(selected).join(', ') + '. Prix : ' + priceText + (v.available ? '' : ', épuisé.'));
    }

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.dataset.optPos;
        selected[pos] = btn.dataset.optValue;
        optionBtns.forEach(function (b) {
          if (b.dataset.optPos === pos) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          }
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        var labelEl = root.querySelector('[data-label-pos="' + pos + '"]');
        if (labelEl) labelEl.textContent = btn.dataset.optValue;
        update();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initProduct();
  });
})();
